import createContext from 'zustand/context'

import { type IProps } from './AudioContext.types'
import { audioStore } from './store'

type AudioStore = ReturnType<typeof audioStore>

const { Provider, useStore } = createContext<AudioStore>()

const AudioContextProvider = ({ children, mediaUrl, audioReady }: IProps) => {
    return (
        <Provider createStore={() => audioStore({ mediaUrl, audioReady })}>
            {children}
        </Provider>
    )
}

export { AudioContextProvider, useStore as useAudioStore }
